<template>
  <div id="map-corridors-container" style="height: 60vh">
    <Popup />
  </div>
</template>

<script>
import * as d3 from 'd3';
import mapServices from '@/services/map';

// components
import Popup from '@/components/ui/map/Popup.vue';

export default {
  name: 'MapCorridors',
  components: {
    Popup,
  },
  data() {
    return {
      map: null,
      defaultOptions: {
        container: 'map-corridors-container',
        style: process.env.VUE_APP_MAPBOX_STYLE_TERRAIN,
        center: [88.9, 37.4],
        zoom: 1.82,
      },
    };
  },
  mounted() {
    // init Mapbox
    this.map = mapServices.createMap(this.defaultOptions);

    this.map.on('load', e => {
      // add corridors layers
      this.loadCorridorLayers();

      // map events
      this.loadCorridorEvents();
    });
  },
  methods: {
    loadCorridorLayers() {
      // geojson data
      this.map.addSource('corridors', {
        type: 'geojson',
        data: '/data/map/corridors/corridors.json',
      });

      // add layer
      this.map.addLayer({
        id: 'corridors',
        type: 'line',
        source: 'corridors',
        layout: {
          'line-cap': 'round',
          'line-join': 'round',
        },
        paint: {
          'line-color': ['string', ['get', 'color'], '#000000'],
          'line-opacity': 0.7,
          'line-width': 5,
        },
      });
    },
    loadCorridorEvents() {
      this.map.dragPan.enable();

      this.map.on('click', e => {
        let isPopup = d3.select('.mapboxgl-custom-popup').style('display') === 'block' ? true : false;

        if (isPopup) {
          // hide popup
          d3.select('.mapboxgl-custom-popup').style('display', 'none');
        }
      });

      this.map.on('click', 'corridors', this.handleMapPopup);
    },
    handleMapPopup(e) {
      console.log('handling popup');

      // the popup element
      const popupEl = d3.select('.mapboxgl-custom-popup');

      // coordinates of for popup
      let coordinates = [e.lngLat.lng, e.lngLat.lat];

      // popup content
      let title = e.features[0].properties.name;
      let description = e.features[0].properties.description;
      let color = e.features[0].properties.color;

      popupEl
        .select('#popup-title')
        .classed('corridor-title', true)
        .style('border-left-color', color);

      // update popup el
      popupEl.style('display', 'block');

      // update popup content
      this.$store.dispatch('popup/updateTitle', title);
      this.$store.dispatch('popup/updateDescription', description);
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~mapbox-gl/dist/mapbox-gl.css';
</style>
